import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Calendar2ComponentDef } from '@df/ui/form/calendar/calendar2.component.def';
@Component({
    selector: 'dropdown-calendar',
    templateUrl: 'dropdown-calendar.html',
    styleUrls: ['dropdown-calendar.scss']
})
export class DropdownCalendarComponent extends Calendar2ComponentDef implements OnInit, OnDestroy {
    /**
     * If triangle should be printed
     */
    @HostBinding('class._triangle')
    @Input()
    triangle: boolean = false;
}
